import React, { useEffect, useState } from 'react';
import { Download, Loader2, History } from 'lucide-react';
import { stockApi } from '../api';
import { downloadStockReport } from './StockImportSummary';

const fmt = (v) => (v ? new Date(/Z|[+-]\d\d:\d\d$/.test(v) ? v : `${v}Z`).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');
const PILL = { success: 'bg-[#E6F2E9] text-[#2f6b41]', partial: 'bg-[#FDF3E1] text-[#8a5a12]', failed: 'bg-[#FBE7E4] text-[#9b2c1f]' };
const SOURCE = { upload: 'Excel upload', email: 'ERP email' };

function ReportRow({ r }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try { await downloadStockReport(r.id, r.reportFileName); } catch (e) { alert(e.message); } finally { setBusy(false); }
  };
  return (
    <tr className="border-t border-[#EFEADB]" data-testid={`stock-report-row-${r.id}`}>
      <td className="px-4 py-2 whitespace-nowrap">{fmt(r.createdAt)}</td>
      <td className="px-4 py-2">{SOURCE[r.source] || r.source}</td>
      <td className="px-4 py-2 text-[12px] text-[#7a6f5c] max-w-[200px] truncate" title={r.by}>{r.by}</td>
      <td className="px-4 py-2 font-mono text-[12px] max-w-[220px] truncate" title={r.fileName}>{r.fileName || '—'}</td>
      <td className="px-4 py-2 text-right">{r.total}</td>
      <td className="px-4 py-2 text-right text-[#2f6b41] font-medium">{r.written}</td>
      <td className="px-4 py-2 text-right text-[#9b2c1f] font-medium">{r.failed}</td>
      <td className="px-4 py-2"><span data-testid={`stock-report-status-${r.id}`} className={`px-2 py-0.5 rounded-full text-[11.5px] font-medium capitalize ${PILL[r.status] || PILL.failed}`}>{r.status}</span></td>
      <td className="px-4 py-2 text-right">
        {r.storagePath ? (
          <button data-testid={`stock-report-download-${r.id}`} onClick={download} disabled={busy} className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border border-[#E7E2D3] bg-white text-[12px] hover:bg-[#F7F4EA] disabled:opacity-50">
            {busy ? <Loader2 size={12} className="animate-spin" /> : <Download size={12} />} Excel
          </button>
        ) : <span className="text-[12px] text-[#7a6f5c]">Not available</span>}
      </td>
    </tr>
  );
}

export default function StockImportHistory({ refreshKey }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { stockApi.reports().then(setRows).catch(() => setRows([])); }, [refreshKey]);
  return (
    <div className="fm-card overflow-hidden mt-4" data-testid="stock-import-history">
      <div className="px-4 py-3 border-b border-[#E7E2D3] flex items-center gap-2">
        <History size={15} className="text-[#7a6f5c]" />
        <div className="text-[14px] font-medium">Stock import reports</div>
        <span className="text-[12px] text-[#7a6f5c]">Last 50 uploads and ERP email imports</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-[13px]">
          <thead><tr className="text-left text-[12px] text-[#7a6f5c]">
            {['Date', 'Source', 'By', 'File', 'Rows', 'Imported', 'Errors', 'Status', 'Report'].map(h => <th key={h} className="px-4 py-2.5 font-medium">{h}</th>)}
          </tr></thead>
          <tbody>
            {rows === null ? <tr><td colSpan={9} className="py-6 text-center"><Loader2 className="animate-spin inline" size={16} /></td></tr>
              : rows.length === 0 ? <tr><td colSpan={9} className="py-6 text-center text-[#7a6f5c]" data-testid="stock-report-empty">No stock imports yet.</td></tr>
              : rows.map(r => <ReportRow key={r.id} r={r} />)}
          </tbody>
        </table>
      </div>
    </div>
  );
}
